import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Icon from 'components/global/Icon';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	width: 100%;
	height: 100%;
	overflow-y: auto;
	padding: var(--padding-4);
`;

export const MobileContainer = styled.div`
	width: 100%;
	height: 100%;
	padding: 0 var(--padding-4);
	background: var(--white);
	border-top: 1px solid var(--border-color);
	${({ $isAccordionVisible }) => $isAccordionVisible && `box-shadow: 0px -3px 5px 1px #0000001a;`}
`;

export const MobileSummaryContent = styled.div`
	padding: 2rem 0;
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const PaymentCard = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	width: 100%;
	padding: 1.5rem 0;
	overflow: hidden;

	:hover {
		cursor: pointer;
	}

	:active {
		cursor: default;
	}

	> * :hover {
		cursor: pointer;
	}

	> * :active {
		cursor: default;
	}

	> .icon.rotate {
		transition: all 0.5s ease;
		transform: rotate(270deg);
	}
	> .icon.rotate0 {
		transition: all 0.5s ease;
		transform: rotate(90deg);
	}
`;

export const UserCardsContainer = styled.div`
	width: 100%;
	width: auto;
	display: grid;
	grid-template-columns: repeat(2, 0fr);
	gap: 1.5rem;
	padding: 1.5rem 1.5rem 1.5rem 0;
	margin-left: 3rem;
	overflow-x: auto;
	overflow-y: hidden;
	scroll-snap-type: x mandatory;
	scroll-behavior: smooth;
	-webkit-overflow-scrolling: touch;
	@media ${Breakpoints.mobile} {
		display: flex;
	}
	body[dir='rtl'] & {
		padding-right: 0;
		margin-right: 3rem;
		margin-left: 0;
	}
`;

export const SummaryContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	padding-top: 2rem;
`;

export const SummaryRow = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	&.expanded {
		> div > .expandIcon > svg {
			transition: transform 0.6s ease;
			transform: rotate(180deg);
		}
	}
	${({ $hasLine }) =>
		$hasLine &&
		css`
			border-top: 1px solid var(--border-color);
			border-bottom: 1px solid var(--border-color);
			padding: 2rem 0;
		`}
	${({ $bottomLine }) =>
		$bottomLine &&
		css`
			border-bottom: 1px solid var(--border-color);
			padding-bottom: 2rem;
		`}
	${({ $topLine }) =>
		$topLine &&
		css`
			border-top: 1px solid var(--border-color);
			padding-top: 2rem;
		`}
	.cod-wallet-switch {
		body[dir='rtl'] & {
			margin-top: 0.5rem;
		}
	}
`;

export const MobileSummaryRow = styled(SummaryRow)`
	padding: 3rem 0;
	${({ $isAccordionVisible }) => $isAccordionVisible && 'border-top: 1px solid var(--border-color);'}
`;

export const PromoCodeContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	width: 100%;
	* > .button {
		flex: 0 0 auto;
	}
`;

export const CODWalletContainer = styled.div`
	display: flex;
	gap: 1.5rem;
	width: 100%;
	.integer-input-container {
		width: 100%;
	}
	& > .button {
		flex: 0 0 auto;
	}
	* .button-icon {
		color: var(--content-4) !important;
	}
`;

export const ExpandIcon = styled(Icon)`
	> svg {
		transition: transform 0.6s ease;
		width: 1rem;
		margin-right: var(--padding-1);
		transform: ${({ expanded }) => (expanded === 'true' ? 'rotate(180deg)' : 'rotate(0deg')};

		body[dir='rtl'] & {
			transform: rotate(180deg);
			margin-right: unset;
			margin-left: var(--padding-1);
		}
	}
`;

export const FlexBox = styled.div`
	display: flex;
	gap: 1rem;
	width: ${({ $width }) => ($width ? $width : '100%')};
	${({ $justifyContent }) => $justifyContent && `justify-content: ${$justifyContent};`}
	${({ $alignItems }) => $alignItems && `align-items: ${$alignItems};`}
	${({ $flexDirection }) => $flexDirection && `flex-direction: ${$flexDirection};`}
	${({ $gap }) => $gap && `gap: ${$gap};`}
`;

export const CODBadge = styled.div`
	background-color: var(--blue);
	border-radius: 400px;
	height: 2.2rem;
	padding: 0.2rem 0.9rem;
	display: flex;
	align-items: center;
	width: max-content;
`;

export const InputWithButton = styled.div`
	display: flex;
	gap: 1rem;
	width: 100%;
	position: relative;
	.input-remove-promo-code {
		position: absolute;
		right: 10px;
		top: 50%;
		transform: translateY(-50%);
	}
`;

export const BankCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	padding: var(--padding-4);
	@media ${Breakpoints.mobile} {
		padding: 0;
	}
	.receipt-upload {
		button {
			width: auto;
			.typography {
				width: initial !important;
			}
		}
	}
`;

export const BankDetails = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: var(--padding-1) var(--padding-4);
	border: 1px solid var(--border-color);
	border-radius: 4px;
	margin-top: 0.5rem;
	margin-bottom: 2rem;
	& > :not(:last-child) {
		border-bottom: 1px solid var(--border-color);
	}
	.form-item {
		width: 100%;
	}
`;

export const BankDetailsRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	width: 100%;
	padding: 1.5rem 0;
	.bank-copy-area {
		background: transparent;
		border: none;
		max-width: 75%;
		justify-content: flex-end;
		width: fit-content;
		& > div {
			display: block;
			margin: 0;
		}
		.typography {
			margin-left: 0;
			body[dir='rtl'] & {
				margin-right: 0;
			}
		}
	}
	:not(:has(.bank-copy-area)) {
		padding: 2rem 0;
	}
	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: flex-start;
		padding: 2rem 0;
		.bank-copy-area {
			max-width: unset;
			justify-content: flex-start;
		}
		:not(:has(.bank-copy-area)) {
			gap: 2rem;
		}
	}
`;

export const CreditCardContainer = styled.div`
	overflow: auto;
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	padding-left: var(--padding-4);
	body[dir='rtl'] & {
		padding-left: 0;
		padding-right: var(--padding-4);
	}
`;

export const CreditCardIFrameContainer = styled.div`
	padding-left: 2rem;
	body[dir='rtl'] & {
		padding-left: 0;
		padding-right: 2rem;
	}
`;

export const AmountWrapper = styled.div`
	margin: 0 auto;
	padding: 4rem 0 8rem 0;
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	@media ${Breakpoints.mobile} {
		padding: 6rem 0 2rem;
	}
`;

export const AmountContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 1.5rem;
	width: 100%;
	margin: var(--margin-2) 0 var(--margin-3) 0;
	@media ${Breakpoints.mobile} {
		grid-template-columns: repeat(2, 1fr);
	}
`;

export const AmountCard = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	height: 7.6rem;
	${({ selected }) =>
		selected &&
		css`
			border-color: var(--blue);
			background: var(--background-1);
		`}
	:hover {
		cursor: pointer;
	}

	@media ${Breakpoints.mobile} {
		height: 10rem;
	}
`;

export const PointContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: flex-end;
	gap: 0.5rem;
	margin: auto;

	&.custom {
		align-items: center;
	}
`;

export const CustomAmountContainer = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: center;
	position: relative;
	gap: 0.3rem;
	margin: auto;
	max-width: 90vw;
	flex-wrap: wrap;
`;

export const InputWrapper = styled.label`
	display: inline-block;
	position: relative;
	width: fit-content;
	&::after {
		content: attr(data-value) ' ';
		visibility: hidden;
		font-size: 6.4rem;
	}
`;

export const AmountInput = styled.input`
	position: absolute;
	bottom: 0;
	left: 0;
	color: var(--black);
	text-align: center;
	font-size: 5.3rem;
	font-weight: 700;
	background: transparent;
	outline: none;
	border: none;
	text-align: end;
	width: 100%;
	height: 5rem;
	appearance: none;
	padding: inherit;
	::placeholder {
		color: var(--black);
		opacity: 0.4;
	}
	&:focus,
	&:hover {
		background: transparent;
		outline: none;
		border: none;
	}
`;

export const AmountBottomContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.5rem;
	padding: 0 12rem;
	@media ${Breakpoints.tablet} {
		padding: 0 var(--padding-4) 0 0;
	}
	@media ${Breakpoints.mobile} {
		padding: 0;
	}
`;

export const CurrentAmount = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
`;

export const ChargeAccountFooter = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	margin-bottom: var(--margin-1);
`;

export const Seperator = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	span {
		margin: 0 2.3rem;
	}
	&::before,
	&::after {
		content: '';
		flex: 1;
		border-bottom: 1px solid var(--border-color);
	}
`;

export const CompletedContainer = styled.div`
	padding-top: 2rem;
	padding-bottom: 4rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;

	.typography {
		text-align: center;
		line-height: 4rem;
		width: 80%;
	}
`;

export const BlackText = styled.span`
	color: var(--black);
	font-weight: 500;
`;

export const TestCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	& > :not(:last-child) {
		border-bottom: 1px solid var(--border-color);
		padding-bottom: 1rem;
	}
`;

export const TestCard = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TestCardRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;

	.copy-area {
		background: transparent;
		border: none;
		max-width: 75%;
		justify-content: flex-end;
		width: fit-content;
		& > div {
			display: block;
			margin: 0;
		}
		.typography {
			margin-left: 0;
			body[dir='rtl'] & {
				margin-right: 0;
			}
		}
	}
	@media ${Breakpoints.mobile} {
		flex-direction: column;
		align-items: flex-start;
		.copy-area {
			max-width: unset;
			justify-content: flex-start;
		}
	}
`;
